import React, { useState } from 'react';
import { t } from '../i18n';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authAPI, productionAPI } from '../api';
import ROLE_HOME from '../roleHome';
import { saveSessionUser } from '../utils/session';

// Старый и новый адрес завода (см. баннер в форме).
const OLD_HOST = 'lamtech.mespro.uz';
const NEW_URL  = 'https://lamtech.mespro.kz';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await authAPI.login(username, password);
      sessionStorage.setItem('access_token', data.access);
      sessionStorage.setItem('refresh_token', data.refresh);
      const { data: user } = await productionAPI.getMe();
      // Служебная учётка — это обмен с 1С, а не человек. Экранов у неё нет, и
      // сессию не открываем вовсе: её пароль лежит в константе 1С, его видит
      // любой, кто откроет конфигуратор, и войти им в программу быть не должно.
      // Обмену это не мешает — он ходит по API и браузер не открывает.
      if (user.role === 'service') {
        sessionStorage.clear();
        toast.error(t('Это служебная учётка обмена с 1С. Входа в программу у неё нет.'));
        return;
      }
      saveSessionUser(user);
      navigate(ROLE_HOME[user.role] || '/manager');
    } catch {
      toast.error(t("Неверный логин или пароль"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--card)', borderRadius: 16, padding: '48px 40px', width: 360, boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14,
            background: 'linear-gradient(135deg, var(--accent), #1d4ed8)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 24, marginBottom: 16
          }}>🏭</div>
          <h1 style={{ color: 'var(--text)', fontSize: 22, fontWeight: 700, margin: 0 }}>{t('LamTech MES')}</h1>
          <p style={{ color: 'var(--dim)', fontSize: 14, marginTop: 6 }}>{t('Система управления производством')}</p>
        </div>

        {/* С 25.09.2026 у завода новый адрес — lamtech.mespro.kz. Старый пока
            работает, чтобы никого не выбросило посреди смены, но закроется:
            здесь люди узнают об этом и переходят сами. Ссылка ведёт на ту же
            страницу — сохранённая закладка на .uz приведёт куда нужно.
            Только для завода: у тренажёра свой адрес, и туда его не шлём. */}
        {OLD_HOST === window.location.hostname && (
          <div style={{
            background: '#f59e0b18', border: '1px solid #f59e0b66', borderRadius: 10,
            padding: '12px 14px', marginBottom: 20, fontSize: 13, lineHeight: 1.5,
            color: 'var(--text)',
          }}>
            <b>Адрес сайта изменился.</b> Теперь входите по адресу{' '}
            <a href={NEW_URL + window.location.pathname + window.location.search}
              style={{ color: 'var(--accent)', fontWeight: 700 }}>lamtech.mespro.kz</a>.
            Старый адрес скоро перестанет работать — сохраните новый в закладки.
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', color: 'var(--muted)', fontSize: 13, marginBottom: 6 }}>{t('Логин')}</label>
            <input type="text" value={username} onChange={e => setUsername(e.target.value)} required style={{
              width: '100%', padding: '10px 14px', background: 'var(--input)',
              border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)',
              fontSize: 15, outline: 'none', boxSizing: 'border-box',
            }} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', color: 'var(--muted)', fontSize: 13, marginBottom: 6 }}>{t('Пароль')}</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required style={{
              width: '100%', padding: '10px 14px', background: 'var(--input)',
              border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)',
              fontSize: 15, outline: 'none', boxSizing: 'border-box',
            }} />
          </div>
          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '12px',
            background: loading ? '#1d4ed8' : 'var(--accent)',
            border: 'none', borderRadius: 8, color: '#fff',
            fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
}
